import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { PathwayTypes, PathwayTypeToLabel } from '@app/pathway-shared';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { ModuleFE_Pathway } from './ModuleFE_Pathway.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_Pathway,
    modules: [ModuleFE_Pathway],
    mapper: item => [item.label],
    placeholder: 'Choose a pathway',
    renderer: item => _jsx(_Fragment, { children: item.label })
};
export const DropDown_Pathway = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Pathway,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_Pathway.selectable,
});
export const MultiSelect_Pathway = TS_MultiSelect_V2.prepare(Props_MultiSelect);
const Props_DropDown_PathwayType = {
    adapter: () => SimpleListAdapter([...PathwayTypes], type => _jsx(_Fragment, { children: PathwayTypeToLabel[type.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Pathway Type',
};
export const Dropdown_PathwayType = TS_DropDown.prepare(Props_DropDown_PathwayType);
//# sourceMappingURL=ui-components.js.map